<template>
  <div>
    <el-form :inline="true" @submit.prevent.native="submitSearch">
      <el-form-item class="list__search-wrapper">
        <el-input
          class="list__search"
          v-model="search"
          clearable=""
          @input="submitSearch"
          placeholder="Name"
        />
      </el-form-item>
      <el-form-item class="list__search-wrapper">
        <el-button @click="submitSearch">{{ $t('search') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="list" v-loading="loading">
      <el-card
        shadow="hover"
        :body-style="{ padding: '0px' }"
        class="item"
        :key="`${image.id}`"
        v-for="image in images"
      >
        <div @click="submitImage(image.id)">
          <img
            class="item__img"
            :src="image.thumbnail && image.thumbnail.url"
            alt=""
          />
          <p class="item__text" v-if="image.title">
            {{ truncate(image.title) }}
          </p>
        </div>
      </el-card>
    </div>

    <el-col :span="24" class="list__pagination">
      <el-pagination
        layout="prev, pager, next"
        :disabled="loading"
        @current-change="handlePageChange"
        :page-size="pageSize"
        :total="count"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import { Image } from '@/api'
import { debounce } from 'lodash'

export default {
  data() {
    return {
      images: [],
      page: 1,
      search: '',
      pageSize: 10,
      count: 0,
      loading: false
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    dialogFormVisible(value) {
      if (value) {
        this.resetFilters()
        this.fetchData()
      }
    }
  },
  methods: {
    submitSearch() {
      this.page = 1
      this.debouncedFetchData()
    },
    resetFilters() {
      this.search = ''
      this.page = 1
    },
    debouncedFetchData: debounce(function () {
      this.fetchData()
    }, 300),
    fetchData() {
      this.loading = true

      const params = {
        search: this.search,
        page: this.page
      }

      this.images = []

      Image.fetch({}, { params })
        .then(response => {
          this.images = response.data.results
          this.pageSize = response.data.page_size
          this.count = response.data.count
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitImage(image) {
      this.$emit('submit', image)
    },
    handlePageChange(value) {
      this.page = value
      this.fetchData()
    },
    truncate(text) {
      if (text) {
        return text.slice(0, 20)
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  grid-gap: 20px 20px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.item {
  cursor: pointer;
  width: 150px;
  text-align: center;
  display: grid;
  align-items: center;
  transition: all 0.3s;

  &__img {
    max-width: 100%;
  }

  &__text {
    margin: 0;
    color: #999;
    font-size: 13px;
  }

  &:hover {
    transform: scale(1.05);
    border-color: #a9a9a9;
  }
}
</style>
